/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

export const LocationPropType = PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    locationName: PropTypes.string,
});

export const MenuPropType = PropTypes.shape({
    categories: PropTypes.array,
    items: PropTypes.array,
    modifierSets: PropTypes.array,
    modifiers: PropTypes.array,
    schedules: PropTypes.array,
});
